import { applicationContextActionCreator } from '../store/actions';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import ServiceBase from './ServiceBase';

class AdminMetricsService extends ServiceBase {
    async assessmentMetrics(accountIds, dateFrom, dateTo) {
        const values = { "accountIds": accountIds, "dateFrom": new Date(dateFrom), "dateTo": new Date(dateTo) };
        var result = await this.requestJson({
            url: `/api/admin/reports/assessment/metrics`,
            method: "POST",
            data: values
        });
        return result;
    }

    async assessmentQAReport(accountIds, dateFrom, dateTo, selectedWorksheets, selectedLocators) {
        const values = {
            "accountIds": accountIds,
            "dateFrom": new Date(dateFrom),
            "dateTo": new Date(dateTo),
            "locators": selectedLocators,
            "worksheetIds": selectedWorksheets
        };
        var result = await this.requestJson({
            url: `/api/admin/reports/assessment/qa`,
            method: "POST",
            data: values
        });
        return result;
    }

    async getEventMetricsAdminDashboard(accountIds, queueIds, assignedToId, fetchRefData) {
        var result = await this.requestJson({
            url: `/api/metrics/admin`,
            method: "POST",
            data: { "accountIds": accountIds, "queueIds": queueIds, "assignedToId": assignedToId, "fetchRefData": fetchRefData }
        });
        return result;
    }

    async allDashboardMetrics() {
        var result = await this.requestJson({
            url: `/api/metrics/all`,
            method: "GET",
            data: undefined
        });
        return result;
    }
}

export default AdminMetricsService;